import AppBar from '@material-ui/core/AppBar';
import React, { Component } from 'react';
import image from '../../Assets/images/commonImages/logo.svg';
import './header.scss';

import Button from '@material-ui/core/Button';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import CloseIcon from '@material-ui/icons/Close';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import MenuIcon from '@material-ui/icons/Menu';
import { instanceOf } from 'prop-types';
import { Modal as HeaderModal } from 'react-bootstrap';
import { Cookies, withCookies } from 'react-cookie';
import { scroller } from 'react-scroll';
// import { pushTrackingEventsToGAAndFB } from '../../global/commonFunctions/GaAndFb';
import { globalVal } from '../../global/globalvalues';
import PostHeader from './PostHeader';
// import { pushTrackingEventsToGAAndFBNew } from '../../global/commonFunctions/GaAndFb';
import TagManager from 'react-gtm-module';

type initialState = {
    anchorEl: any;
    anchorEl1: any;
    anchorEl3: any;
    phoneOptionSelected: any;
    servicesOptionSelected: any;
    user: any;
    isShowPlan: boolean;
    isModal: boolean;
    isServiceEnable: boolean;
    isPhoneEnable: boolean;
    customer: any;
};
type initialProps = { history: any; isMyAccount?: any; cookies: any };

export class header extends Component<initialProps, initialState> {
    static propTypes = {
        cookies: instanceOf(Cookies).isRequired,
    };
    state = {
        anchorEl: null,
        anchorEl1: null,
        anchorEl3: null,
        phoneOptionSelected: '',
        servicesOptionSelected: '',
        user: { displayName: '' },
        isShowPlan: true,
        isModal: false,
        isServiceEnable: false,
        isPhoneEnable: false,
        customer: { simPaid: false, status: 0 },
    };
    componentDidMount() {
        let user1: any = localStorage.getItem('currentuser');
        user1 = JSON.parse(user1);
        user1 &&
            !user1.isAnonymous &&
            this.setState({
                user: user1,
            });
        let customer: any = localStorage.getItem('customerDetail');
        customer = JSON.parse(customer);
        if (customer && customer.simPaid) {
            this.setState({
                customer: {
                    simPaid: customer.simPaid,
                    status: customer.status,
                },
            });
        }
        customer &&
            customer &&
            customer.shipmentInfo &&
            customer.reachPlanId &&
            Object.keys(customer.shipmentInfo).length > 0 &&
            Object.keys(customer.shipmentInfo)[0] &&
            this.setState({
                isShowPlan: false,
            });
    }

    // GAAndFBEventsHandler = (category: string, actionType: string) => {
    //     pushTrackingEventsToGAAndFB({
    //         category: category,
    //         actionType: actionType,
    //     });
    // };
    // GAAndFBEventsHandler =(buttonVal: string) => {
    //     pushTrackingEventsToGAAndFBNew("event", buttonVal, {
    //       screenName: "home",
    //       buttonValue: buttonVal, 
    //     });
    //   };

    handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
        this.setState({
            anchorEl: event.currentTarget,
        });
    };
    handleLogout = () => {
        localStorage.clear();
        const { cookies } = this.props;
        cookies.remove('astoundAccessToken');
        window.location.href = `${process.env.REACT_APP_ASTOUND_SSO_LOGOUT_URL}`;
        // this.props.history.push('/mobile-login');
        // this.GAAndFBEventsHandler("Logout")
        TagManager.dataLayer({
            dataLayer: {
              event: "Logout",
            },
          });
    };

    handleClose = () => {
        this.setState({
            anchorEl: null,
        });
    };
    handleClick1 = (event: React.MouseEvent<HTMLButtonElement>) => {
        this.setState({
            anchorEl1: event.currentTarget,
        });
    };
    handleClick3 = (event: React.MouseEvent<HTMLButtonElement>) => {
        this.setState({
            anchorEl3: event.currentTarget,
        });
    };
    handlePhoneOptions = (e: any) => {
        this.setState({
            phoneOptionSelected: e,
        });
        if (e === 'Buy a phone') {
            // this.GAAndFBEventsHandler('Header', 'Buy Phone');
            window.open('https://www.shop.reachmobile.com/Phones/', '_blank');
        } else if (e === 'Bring your own') {
            // this.GAAndFBEventsHandler('Header', 'Bring Your Own');
            this.props.history.push('/imei-compatibility-check');
        }
        this.handleClose1();
    };
    handleServicesOptions = (e: any) => {
        this.setState({
            servicesOptionSelected: e,
        });
        if (e === 'International Services') {
            this.props.history.push('/international_services');
        }
        this.handleClose();
    };

    handleClose1 = () => {
        this.setState({
            anchorEl1: null,
        });
    };
    handleClose3 = () => {
        this.setState({
            anchorEl3: null,
        });
    };
    handleClickedMiddleButtons = (e: any) => {
        if (e === 'Plans') {
            // this.GAAndFBEventsHandler('Header', 'Plans');
            this.props.history.push('/home');
            setTimeout(function() {
                scroller.scrollTo('bestCellPhonePlan', {
                    duration: 1000,
                    delay: 0,
                    smooth: 'easeInOutQuart',
                    smooh: 'easeOutQuart',
                    offset: -100,
                });
            }, 1000);
        } else if (e === 'Best Fit') {
            // this.GAAndFBEventsHandler('Header', 'Best Fit');
            this.props.history.push('/bestfit');
        } else if (e === 'Give Back') {
            // this.GAAndFBEventsHandler('Header', 'Give Back');
            this.props.history.push('/giveback');
        } else if (e === 'Blog') {
            // this.GAAndFBEventsHandler('Header', 'Blog');
            window.open('https://connect.reachmobile.com/', '_blank');
        } else if (e === 'Sign In') {
            // this.GAAndFBEventsHandler('Header', 'Sign In');
            this.props.history.push('/login');
        } else if (e === 'Help') {
            // this.GAAndFBEventsHandler('Header', 'Help');
            this.props.history.push('/help');
        }
    };
    openModal = () => {
        this.setState({
            isModal: true,
        });
    };
    onHide = () => {
        this.setState({ isModal: false });
    };
    toggleServices = () => {
        this.setState({
            isServiceEnable: !this.state.isServiceEnable,
        });
    };
    togglePhone = () => {
        this.setState({
            isPhoneEnable: !this.state.isPhoneEnable,
        });
    };

    render() {
        const { user, isShowPlan, customer } = this.state;
        return (
            <>
                {customer !== null && customer?.simPaid && customer?.status === 2 ? (
                    <PostHeader history={this.props.history} />
                ) : (
                    <div className="headerMain">
                        <AppBar position="fixed" className="headerContent">
                            <div className="headerInnerDiv">
                                <div onClick={() => this.props.history.push('/')}>
                                    <img
                                        className="headerLogo"
                                        src={globalVal && globalVal.logo ? globalVal.logo : image}
                                        alt="Astound mobile logo"
                                    />
                                </div>
                                <div className="arrayDivHeader">
                                    {isShowPlan && (
                                        <div
                                            className={
                                                window.location.pathname === '/cell-phone-plans'
                                                    ? 'buttonMiddleHeader activeRouteHeader'
                                                    : 'buttonMiddleHeader'
                                            }
                                        >
                                            <Button
                                                aria-controls="simple-menu"
                                                className="fontStyleheader"
                                                aria-haspopup="true"
                                                onClick={async () => {
                                                    if (this.props?.history?.location?.pathname !== '/') {
                                                        await this.props.history.push('/');
                                                    }
                                                    // this.GAAndFBEventsHandler('Header', 'Plans');
                                                    this.handleClickedMiddleButtons('Plans');
                                                }}
                                            >
                                                Plans
                                            </Button>
                                        </div>
                                    )}
                                    <div
                                        className={
                                            window.location.pathname === '/bestfit'
                                                ? 'buttonMiddleHeader activeRouteHeader'
                                                : 'buttonMiddleHeader'
                                        }
                                    >
                                        <Button
                                            aria-controls="simple-menu"
                                            aria-haspopup="true"
                                            className="fontStyleheader"
                                            onClick={() => {
                                                this.handleClickedMiddleButtons('Best Fit');
                                                // this.GAAndFBEventsHandler('Header', 'Best Fit Savings');
                                            }}
                                        >
                                            BEST FIT™ SAVINGS
                                        </Button>
                                    </div>
                                    <div
                                        className={
                                            window.location.pathname === '/international_services'
                                                ? 'buttonMiddleHeader activeRouteHeader'
                                                : 'buttonMiddleHeader'
                                        }
                                    >
                                        <Button
                                            aria-controls="simple-menu"
                                            aria-haspopup="true"
                                            className={
                                                this.state.anchorEl
                                                    ? 'clickedHeaderTab fontStyleHeader'
                                                    : 'fontStyleHeader'
                                            }
                                            onClick={this.handleClick}
                                        >
                                            Services{' '}
                                            {this.state.anchorEl ? (
                                                <KeyboardArrowUpIcon className="ArrowUpKey" />
                                            ) : (
                                                <KeyboardArrowDownIcon />
                                            )}
                                        </Button>
                                        <Menu
                                            id="simple-menu"
                                            className="HeaderDropdown"
                                            anchorEl={this.state.anchorEl}
                                            keepMounted
                                            open={Boolean(this.state.anchorEl)}
                                            onClose={this.handleClose}
                                        >
                                            <MenuItem
                                                className="menuitemHeader"
                                                onClick={() => {
                                                    this.handleServicesOptions('International Services');
                                                    // this.GAAndFBEventsHandler('Header', 'International Services');
                                                }}
                                            >
                                                International Services
                                            </MenuItem>
                                        </Menu>
                                    </div>
                                    <div
                                        className={
                                            window.location.pathname === '/buy_a_phone' ||
                                            window.location.pathname === '/imei-compatibility-check'
                                                ? 'buttonMiddleHeader activeRouteHeader'
                                                : 'buttonMiddleHeader'
                                        }
                                    >
                                        <Button
                                            aria-controls="simple-menu"
                                            aria-haspopup="true"
                                            className={
                                                this.state.anchorEl1
                                                    ? 'clickedHeaderTab fontStyleHeader'
                                                    : 'fontStyleHeader'
                                            }
                                            onClick={this.handleClick1}
                                        >
                                            phones{' '}
                                            {this.state.anchorEl1 ? (
                                                <KeyboardArrowUpIcon className="ArrowUpKey" />
                                            ) : (
                                                <KeyboardArrowDownIcon />
                                            )}
                                        </Button>
                                        <Menu
                                            id="simple-menu"
                                            className="HeaderDropdown"
                                            anchorEl={this.state.anchorEl1}
                                            keepMounted
                                            open={Boolean(this.state.anchorEl1)}
                                            onClose={this.handleClose1}
                                        >
                                            <MenuItem
                                                className="menuitemHeader"
                                                onClick={() => this.handlePhoneOptions('Buy a phone')}
                                            >
                                                Buy a phone
                                            </MenuItem>
                                            <MenuItem
                                                className="menuitemHeader"
                                                onClick={() => this.handlePhoneOptions('Bring your own')}
                                            >
                                                Bring your own
                                            </MenuItem>
                                        </Menu>
                                    </div>

                                    <div
                                        className={
                                            window.location.pathname === '/giveback'
                                                ? 'buttonMiddleHeader activeRouteHeader'
                                                : 'buttonMiddleHeader'
                                        }
                                    >
                                        <Button
                                            aria-controls="simple-menu"
                                            aria-haspopup="true"
                                            className="fontStyleHeader"
                                            onClick={() => this.handleClickedMiddleButtons('Give Back')}
                                        >
                                            Give Back
                                        </Button>
                                    </div>
                                </div>
                                <div className="arrayDivHeader otherButtons">
                                    {this.props.isMyAccount && (
                                        <div className={'buttonMiddleHeader'}>
                                            <Button
                                                aria-controls="simple-menu"
                                                aria-haspopup="true"
                                                onClick={() => this.props.history.push({
                                                    pathname: '/activation',
                                                    state: {
                                                        redirectOnClick: true,
                                                    },
                                                })}
                                            >
                                                Activate
                                            </Button>
                                        </div>
                                    )}
                                    {!this.props.isMyAccount && (
                                        <div className={'buttonMiddleHeader'}>
                                            <Button
                                                aria-controls="simple-menu"
                                                aria-haspopup="true"
                                                onClick={() => this.handleClickedMiddleButtons('Blog')}
                                            >
                                                Blog
                                            </Button>
                                        </div>
                                    )}
                                    {!this.props.isMyAccount && (
                                        <div className={'buttonMiddleHeader'}>
                                            <Button
                                                aria-controls="simple-menu"
                                                aria-haspopup="true"
                                                className="fontStyleHeader"
                                                onClick={() => this.handleClickedMiddleButtons('Help')}
                                            >
                                                HELP
                                            </Button>
                                        </div>
                                    )}

                                    <div className={'buttonMiddleHeader1'}>
                                        {user && user.displayName !== '' ? (
                                            <div className="lastDiv1">
                                                <Button
                                                    aria-controls="simple-menu"
                                                    aria-haspopup="true"
                                                    className={
                                                        this.state.anchorEl
                                                            ? 'clickedHeaderTab fontStyleHeader'
                                                            : 'fontStyleHeader'
                                                    }
                                                    onClick={this.handleClick3}
                                                >
                                                    <div className="innerLast">
                                                        <AccountCircleIcon />
                                                        <div className="name username">
                                                            {user.displayName &&
                                                                user.displayName !== '' &&
                                                                user.displayName.split(' ')[0]}
                                                        </div>
                                                    </div>
                                                </Button>
                                                <Menu
                                                    id="simple-menu"
                                                    className="SimpleHeaderDropdown"
                                                    anchorEl={this.state.anchorEl3}
                                                    keepMounted
                                                    open={Boolean(this.state.anchorEl3)}
                                                    onClose={this.handleClose3}
                                                >
                                                    {!isShowPlan && customer.simPaid && (
                                                        <MenuItem
                                                            className="menuitemHeader"
                                                            onClick={() => {
                                                                this.props.history.push('/profile');
                                                                // this.GAAndFBEventsHandler('Header', 'Profile');
                                                            }}
                                                        >
                                                            Profile
                                                        </MenuItem>
                                                    )}
                                                    <MenuItem
                                                        className="menuitemHeader"
                                                        onClick={() => {
                                                            this.handleLogout();
                                                            // this.GAAndFBEventsHandler('Header', 'LogOut');
                                                        }}
                                                    >
                                                        Log out
                                                    </MenuItem>
                                                </Menu>
                                            </div>
                                        ) : (
                                            <Button
                                                aria-controls="simple-menu"
                                                aria-haspopup="true"
                                                className="fontStyleHeader paddingAdded"
                                                onClick={() => this.handleClickedMiddleButtons('Sign In')}
                                            >
                                                Sign In | Activate
                                            </Button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </AppBar>

                        <AppBar position="fixed" className="headerContentMobile">
                            <div className="headerContentMobileinner">
                                <div onClick={() => this.props.history.push('/')}>
                                    <img
                                        className="headerLogoMobile"
                                        src={globalVal && globalVal.logo ? globalVal.logo : image}
                                        alt="Astound mobile logo"
                                    />
                                </div>
                                <div>
                                    <MenuIcon
                                        style={{
                                            color: 'var(--primary_color1)',
                                            width: '45px',
                                            height: '51px',
                                            padding: '0px 0px 0px 15px',
                                            marginRight: '12px',
                                        }}
                                        onClick={this.openModal}
                                    />
                                </div>
                            </div>
                        </AppBar>
                        <HeaderModal
                            show={this.state.isModal}
                            onHide={() => this.onHide()}
                            size={'xl'}
                            className="modalMainHeader"
                            aria-labelledby="contained-modal-title-vcenter"
                            centered
                        >
                            <CloseIcon className="closeIcon" onClick={() => this.onHide()} />
                            <div className="bottomContent">
                                {isShowPlan && (
                                    <div
                                        className={
                                            window.location.pathname === '/cell-phone-plans'
                                                ? 'menuItems activeRouteHeader'
                                                : 'menuItems'
                                        }
                                        onClick={() => this.handleClickedMiddleButtons('Plans')}
                                    >
                                        PLANS
                                    </div>
                                )}
                                <div
                                    className={
                                        window.location.pathname === '/bestfit'
                                            ? 'menuItems activeRouteHeader'
                                            : 'menuItems'
                                    }
                                    onClick={() => this.handleClickedMiddleButtons('Best Fit')}
                                >
                                    BEST FIT™ SAVINGS
                                </div>
                                <div
                                    className={
                                        window.location.pathname === '/international_services'
                                            ? 'menuItems dropdownL  activeRouteHeader'
                                            : 'menuItems dropdownL'
                                    }
                                    onClick={() => this.toggleServices()}
                                >
                                    SERVICES
                                    {this.state.isServiceEnable ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </div>
                                {this.state.isServiceEnable && (
                                    <div
                                        className={
                                            window.location.pathname === '/international_services'
                                                ? 'subMenuItems  activeRouteHeader'
                                                : 'subMenuItems'
                                        }
                                        onClick={() => this.handleServicesOptions('International Services')}
                                    >
                                        International Services
                                    </div>
                                )}
                                <div
                                    className={
                                        window.location.pathname === '/buy_a_phone' ||
                                        window.location.pathname === '/imei-compatibility-check'
                                            ? 'menuItems dropdownL  activeRouteHeader'
                                            : 'menuItems dropdownL'
                                    }
                                    onClick={() => this.togglePhone()}
                                >
                                    PHONES
                                    {this.state.isPhoneEnable ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                </div>
                                {this.state.isPhoneEnable && (
                                    <div>
                                        <div
                                            className={
                                                window.location.pathname === '/buy_a_phone'
                                                    ? 'subMenuItems  activeRouteHeader'
                                                    : 'subMenuItems'
                                            }
                                            onClick={() => this.handlePhoneOptions('Buy a phone')}
                                        >
                                            Buy a phone
                                        </div>
                                        <div
                                            className={
                                                window.location.pathname === '/imei-compatibility-check'
                                                    ? 'subMenuItems  activeRouteHeader'
                                                    : 'subMenuItems'
                                            }
                                            onClick={() => this.handlePhoneOptions('Bring your own')}
                                        >
                                            Bring your own
                                        </div>
                                    </div>
                                )}
                                <div
                                    className={
                                        window.location.pathname === '/giveback'
                                            ? 'menuItems  activeRouteHeader'
                                            : 'menuItems'
                                    }
                                    onClick={() => this.handleClickedMiddleButtons('Give Back')}
                                >
                                    GIVE BACK
                                </div>
                                {!this.props.isMyAccount && (
                                    <div
                                        className="menuItems greyColor"
                                        onClick={() => this.handleClickedMiddleButtons('Blog')}
                                    >
                                        BLOG
                                    </div>
                                )}
                                {!this.props.isMyAccount && (
                                    <div
                                        className="menuItems greyColor"
                                        onClick={() => this.handleClickedMiddleButtons('Help')}
                                    >
                                        HELP
                                    </div>
                                )}
                                {this.props.isMyAccount && (
                                    <div
                                        className="menuItems greyColor"
                                        onClick={() => this.props.history.push({
                                            pathname: '/activation',
                                            state: {
                                                redirectOnClick: true,
                                            },
                                        })}
                                    >
                                        ACTIVATE
                                    </div>
                                )}
                                {user && user.displayName !== '' ? (
                                    <div>
                                        {!isShowPlan && customer.simPaid && (
                                            <div
                                                className="menuItems greyColor"
                                                onClick={() => this.props.history.push('/profile')}
                                            >
                                                PROFILE
                                            </div>
                                        )}

                                        <div className="menuItems greyColor" onClick={() => this.handleLogout()}>
                                            Log out
                                        </div>
                                    </div>
                                ) : (
                                    <div
                                        className="menuItems greyColor"
                                        onClick={() => this.handleClickedMiddleButtons('Sign In')}
                                    >
                                        SIGN IN | ACTIVATE
                                    </div>
                                )}
                            </div>
                        </HeaderModal>
                    </div>
                )}
            </>
        );
    }
}

export default withCookies(header);
